import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export default function RolloutProductUpdateImpactTag({
  impactLevel
}) {
  if (impactLevel === null) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: "--"
    });
  }
  switch (true) {
    case impactLevel >= 7:
      return /*#__PURE__*/_jsx(Tag, {
        use: "danger",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.impact.high"
        })
      });
    case impactLevel >= 3 && impactLevel <= 6:
      return /*#__PURE__*/_jsx(Tag, {
        use: "warning",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.impact.medium"
        })
      });
    case impactLevel >= 0 && impactLevel <= 2:
      return /*#__PURE__*/_jsx(Tag, {
        use: "active",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.impact.low"
        })
      });
    default:
      return /*#__PURE__*/_jsx(_Fragment, {
        children: "--"
      });
  }
}
RolloutProductUpdateImpactTag.FilterOptions = ['LOW', 'MEDIUM', 'HIGH'];